export const isPropValid = (v: string) => !v.startsWith("$");
